import { css } from '@emotion/react'
import React from 'react'
import { Tooltip, colors } from 'plume-ui'
import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'

type Offset = { top?: number }
type Size = 'medium' | 'large'

export type HelpProps = {
  linkTo?: string
  offset?: Offset
  size?: Size
  className?: string
}

export const Help: React.FC<HelpProps & { children?: string }> = (props) => {
  if (props.linkTo) {
    return (
      <>
        <Tooltip
          label={props.children ? props.children?.toString() : ''}
          id="help"
          css={css`
            line-height: 1;
          `}
        >
          <a
            href={props.linkTo}
            target="_blank"
            rel="noopener"
            css={css`
              color: ${colors.black10};
              vertical-align: middle;
              &:active,
              &:visited {
                color: ${colors.black10};
              }
            `}
          >
            <Icon
              text={props.children}
              className={props.className}
              size={props.size}
              offset={props.offset}
            />
          </a>
        </Tooltip>
      </>
    )
  }

  return (
    <>
      <Tooltip
        label={props.children ? props.children?.toString() : ''}
        id="help"
        css={css`
          line-height: 1;
        `}
      >
        <Icon
          text={props.children}
          className={props.className}
          size={props.size}
          offset={props.offset}
        />
      </Tooltip>
    </>
  )
}

const Icon: React.FC<{
  text?: string
  offset?: Offset
  size?: Size
  className?: string
}> = (props) => {
  const offset = `{'top': ${props.offset?.top || 0}}`

  return (
    <span
      data-for="help"
      data-offset={offset}
      data-tip={props.text}
      className={props.className}
    >
      <IcomoonIcon
        name="question-circle-fill"
        css={css`
          font-size: ${props.size === 'large' ? '20px' : '14px'};
        `}
      />
    </span>
  )
}
